import RA from 'ra-config'
import colors from 'lib/components/charts/colors'
import { ensureArray } from 'lib/array'

const { categoryList } = RA.app.strategies
const { colorList } = RA.app

const DEFAULT_COLOR = colors.default

/**
 * @param String categoryName - the name of the category to fetch a color for
 * @param Number shade - how much to adjust the color in order to produce a different shade
 * @return String hsl - hsl color string
 **/
export function getColor(categoryName, shade = 0) {
  return getShaded(getColorByCategory(categoryName), shade)
}

/**
 * @param String categoryName - the name of the category to fetch a color for
 * @return Object hsl - { h: Number, s: Number, l: Number }
 **/
export function getColorByCategory(categoryName) {
  const category = categoryList.find(({ name }) => name === categoryName)
  return getColorByKey(category && category.color)
}

export function getColorByKey(colorKey) {
  return colorList[colorKey] ? colorList[colorKey].hsl : DEFAULT_COLOR
}

/**
 * @param Object hsl - { h: Number, s: Number, l: Number }
 * @param Number shade - how much to adjust the color in order to produce a different shade
 * @return String
 **/
export function getShaded(hsl, shade = 0) {
  return `hsl(${hsl.h + shade * 5}, ${hsl.s - shade * 10}%, ${hsl.l +
    shade * 10}%)`
}

/**
 * Generate a map of uniquely shaded colors. This is used by line charts
 * to ensure colors are always unique, even if strategies come from the
 * same category.
 * @param {Array<Object>} items - A pool of items to compare
 * @param {String|Function} pluck - The key to store the result color with
                                    or a function that generates the key
                                    from the item
 * @returns {Object} A map of unique colors shaded by key
 */

export function getShades(items, pluck) {
  let getKey = pluck

  if (typeof pluck === 'string') {
    getKey = item => item[pluck]
  }

  return ensureArray(items).reduce((memo, item, i) => {
    const color = item.Color
    let shade = 0

    while (i-- > 0) {
      if (items[i].Color.toString() === color.toString()) shade += 1
    }

    memo[getKey(item)] = getShaded(color, shade)

    return memo
  }, {})
}

export default colors



// WEBPACK FOOTER //
// ./src/config/colors.js